import { Modal, Form, IFormContext }                 from 'rewire-ui';
import { reasonCategorySearcher, ReasonInsertInput } from '../DataTypes';
import DataMutations                                 from '../graphql/Mutations';
import { notifications }                             from '../ui/Notifications';

class AddReasonDialogModel extends Modal {
  form: Form;

  constructor() {
    super('Add Reason');

    this.form = Form.create((form: IFormContext) => ({
      name:     form.string().label('Name').validators('required').placeholder('enter name').autoFocus(),
      code:     form.string().label('Code').placeholder('enter code'),
      category: form.select(reasonCategorySearcher).label('Category').placeholder('enter category'),
    }));
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
  }

  load() {
    this.reset();
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const reasonInput: ReasonInsertInput = {
      name:     this.form.field.name.value,
      code:     this.form.field.code.value,
      category: this.form.field.category.value,
    };

    const result = await DataMutations.insertReasons('', [reasonInput]);
    if (result && result[0]) {
      notifications.success('Reason Created');
      return true;
    }

    notifications.error('Reason Creation Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const addReasonDialogModel = new AddReasonDialogModel();
export default addReasonDialogModel;
